import AppVideoPlayer from './VideoPlayer.vue';
import AppMediaControlSeek from './ControlSlider.vue';
import AppMediaControlPlay from './ControlPlay.vue';
import AppMediaControls from './MediaControls.vue';
import AppMediaNetworkLoader from './MediaNetworkLoader.vue';

export default { AppVideoPlayer, AppMediaControlSeek, AppMediaControlPlay, AppMediaControls, AppMediaNetworkLoader };
